import customSocialIcons from "../../utils/customSocialIcons.js";

import sFloridaMainFeature from "../widgets/sFloridaMainFeature.js";
import sFloridaSeoBlock from "../widgets/sFloridaSeoBlock.js";
import sFloridaCardWidget from "../widgets/sFloridaCardWidget.js";
import sFloridaVideo from "../widgets/sFloridaVideo.js";
import * as sFloridaSocialNetworkWidget from "../widgets/sFloridaSocialNetworkWidget.js";

import * as utils from "../../utils/utils.js";

let themeName;
let themeURL;

// -------------------------
// HEADER
function createHeader(sparkThemeConfig) {
  themeName = sparkThemeConfig[2].navItemName;
  themeURL = sparkThemeConfig[2].navItemUrl;

  customSocialIcons("sFloridaSocialSideBar", sFloridaSocialSideBarOpts, 8);

  const themeHeading = "southFlorida-header";
  $(".header").addClass(themeHeading);

  const headerStructure = `
      <div class="${themeHeading}InnerContent">
        <div class="top-bar">
          <div class="inner-content">
            <div class="left-panel"></div>
            <div class="right-panel">
              <div class="search-container"></div>
            </div>
          </div>
        </div>

        <div class="mid-bar">
          <div class="inner-content">
            <div class="logo-container"></div>
            <div class="right-content">
              <div class="ticket-container">
                
              </div>
            </div>
          </div>
        </div>
      </div>`;

  $(`.${themeHeading}`).append(headerStructure);

  const topBarContentLeft = $(
    `.${themeHeading} .${themeHeading}InnerContent .top-bar .inner-content .left-panel`
  );
  const topBarContentRight = $(
    `.${themeHeading} .${themeHeading}InnerContent .top-bar .inner-content .right-panel`
  );
  const sFloridaTopLinks = $("#static-top-links");
  const headerSearch = $(`.${themeHeading}-content .searchBox`);
  const headerDirections = $(`.${themeHeading}-content .standAloneDirections`);
  const headerLogin = $(`.${themeHeading}-content .header-login`);
  const headerCart = $(`.${themeHeading}-content .viewcart`);
  const headerToggle = $(`.${themeHeading} .mobile-nav-toggle`);
  const headerNav = $(`.${themeHeading} #mainNavigation`);
  const headerLogo = $(`.${themeHeading} .header-logo`);
  const customAboutUs = $(`.${themeHeading}-content .header-aboutUs`);
  const customTickets = $(`.${themeHeading}-content .sFTicket`);

  $(topBarContentLeft).append(sFloridaTopLinks);

  $(topBarContentRight).append(
    headerDirections,
    customAboutUs,
    headerLogin,
    headerCart
  );
  $(topBarContentRight).find(".search-container").append(headerSearch);

  $(`.${themeHeading} .header-logo`).appendTo(
    `.${themeHeading} .mid-bar .logo-container`
  );
  $(`.${themeHeading} #siteInfoBannerWidget`).appendTo(
    `.${themeHeading} .mid-bar .logo-container`
  );

  $(customTickets).appendTo(`.${themeHeading} .mid-bar .ticket-container`);

  $(headerLogo).attr("aria-label", `${themeName}`);
  $(headerLogo).attr("href", `${themeURL}`);
  $(headerNav).prependTo(`.${themeHeading} .mid-bar .right-content`);
  $(headerToggle).appendTo(`.${themeHeading} .mid-bar .right-content`);
  $(headerCart).clone().prependTo(`.${themeHeading} .mid-bar .right-content`);

  utils.removeOldHeader(themeHeading);
  utils.customizeSearchBar(themeHeading, "searchBox", "Search Website");
  headingSpecialFeature(customAboutUs);

  $(window).load(function () {
    setTimeout(() => {
      $(body).addClass("bannerReady");
      if (
        !$(body).hasClass("siteInfoBannerWidgetEventHappening") &&
        !$(body).hasClass("siteInfoBannerWidgetDateIsPast")
      ) {
        let daysCount = $("#siteInfoBannerWidget .countdownDays").text();
        let newEventName = $("#siteInfoBannerWidget #eventName");
        if (daysCount != "Thanks for a great event!") {
          $(newEventName).remove();
          $("#siteInfoBannerWidget").append(
            `<div id="eventName"><span>-</span>${daysCount} away</div>`
          );
          $("#siteInfoBannerWidget").css("opacity", "1");
        }
      }
      $("#siteInfoBannerWidget").css("opacity", "1");
    }, 2000);
  });
}

// -------------------------
// Special functions for theme

function headingSpecialFeature(pageAppend) {
  $(".mobile-nav-toggle").click(function () {
    $(".mobile-menu-container #mobile-nav").append(
      `<a href="${pageAppend.attr(
        "href"
      )}" class="mobile-aboutUs">${pageAppend.text()}</a>`
    );
  });
}
// -------------------------

// -------------------------
// HOMEPAGE CONTENT
function createContent() {
  sFloridaMainFeature();
  sFloridaSeoBlock();
  sFloridaCardWidget();

  $(window).load(function () {
    sFloridaVideo();
    sFloridaSocialNetworkWidget.facebookfeed(true);
    sFloridaSocialNetworkWidget.instafeed(true);
  });

  $(".content").empty();
  $(".content").addClass("southFlorida-content");
  const contentStructure = `
      <div class="tier-1-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-2-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-3-container">
        <div class="inner-content"></div>
      </div>

      <div class="tier-4-container">
        <div class="inner-content">
          <div class="left-panel"></div>
          <div class="right-panel">
            <div class="social-wrap"></div>
          </div>
        </div>
      </div>

      <div class="tier-5-container">
        <div class="inner-content"></div>
      </div>`;

  $(".southFlorida-content").append(contentStructure);

  // Main slider
  const sFloridaSlider = $("#sFloridaMainFeature");
  $(".southFlorida-content .tier-1-container .inner-content").append(
    sFloridaSlider
  );

  // Seo Block section
  const sFloridaSeo = $("#sFloridaSeoBlock");
  $(".southFlorida-content .tier-2-container .inner-content").append(
    sFloridaSeo
  );

  const sFloridaSeoContent = $("#sFloridaSeoBlockSection");
  $(".southFlorida-content .tier-2-container .inner-content").append(
    sFloridaSeoContent
  );

  // Cards sections
  const sFloridaCards = $("#sFloridaCardWidget");
  $(".southFlorida-content .tier-3-container .inner-content").append(
    sFloridaCards
  );

  // Social and video section
  const signupSection = $("#sf-signup-section .signup-container");
  const signUpForm = $("#sf-signup-section .emailSignup");
  const sfVideo = $("#videoWidget");

  $(
    ".southFlorida-content .tier-4-container .inner-content .left-panel"
  ).append(signupSection);
  $(
    ".southFlorida-content .tier-4-container .inner-content .left-panel .signup-form"
  ).append(signUpForm);

  let signUpElements = $("#sf-signup-container .emailSignup");
  $(signUpElements).find(".emailSignupText").text("").append(`
  <div class="signup-text">
  <h2>Email Sign Up</h2>
  <div class="signup-description">
  <span>Sign up today for the latest fair news and deals.</span>
  <span>Get them delivered right to your inbox!</span>
  </div>
  </div>
  `);
  $(signUpElements)
    .find(".emailInputField, .emailInputSubmit")
    .wrapAll('<div class="input-wrap"></div>');
  $(signUpElements)
    .find(".emailInputSubmit a")
    .wrap('<div class="btn-wrap"></div>');
  $(signUpElements).find(".btn-wrap a").text("");
  $(signUpElements).find(".btn-wrap a").text("Subscribe");
  $(signUpElements).find(".emailInputField input").val("");
  $(signUpElements)
    .find(".emailInputField input")
    .attr("placeholder", "Enter Email");

  $(
    ".southFlorida-content .tier-4-container .inner-content .left-panel"
  ).append(sfVideo);

  const socialWidget = $("#sFloridaSocialNetworkWidget");
  $(
    ".southFlorida-content .tier-4-container .inner-content .right-panel .social-wrap"
  ).append(socialWidget);

  // Sponsors
  const sponsors = $("#sponsorWidgetContainer");
  $(".southFlorida-content .tier-5-container .inner-content").append(sponsors);

  $('.afterContent').remove();
}

// -------------------------
// FOOTER
function createFooter() {
  const footerClass = "southFloridaFooter";

  $(".footer").addClass(`${footerClass}`);

  const footerStructure = `
      <div class="section-a">
          <a class="southFlorida-logo" 
          href="${themeURL}" 
          aria-label="${themeName}">
          </a>
      </div>
      <div class="section-b"></div>
      <div class="section-c">
          <span class="footer-haeding">Site Map</span>
      </div>
      <div class="section-d"></div>
      <div class="footer-social"></div>`;

  const footeraAbstract = `
      <div class="abstract">
        <div class="line-1"></div>
        <div class="line-2"></div>
        <div class="line-3"></div>
      </div>`;

  const southFloridaBase = $(
    `.${footerClass} .southFlorida-footer .southFlorida-wrapper`
  );
  const southFloridaFooterInfo = $(
    `.${footerClass} .southFlorida-footer .info-data`
  );
  const southFloridaNavigation = $(".main-theme-footer .footer-navigation");
  const southFloridaCopy = $(".main-theme-footer .copy-container");
  const footerSocial = $("#sFloridaSocialSideBar");

  $(southFloridaBase).append(footerStructure);
  $(`.${footerClass}`).prepend(`${footeraAbstract}`);
  $(southFloridaBase).find(".section-b").append(southFloridaFooterInfo);
  $(southFloridaBase).find(".section-c").append(southFloridaNavigation);
  $(southFloridaBase).find(".section-d").append(southFloridaCopy);
  $(southFloridaBase).find(".footer-social").append(footerSocial);

  $(".footer .main-theme-footer").remove();
  $(".footer .yesteryear-footer").remove();
  $(".footer .ag-zone-footer").remove();
}

export { createHeader, createContent, createFooter };
